import React, { useState, useContext, useEffect } from 'react'
import moment from 'moment'
import axios from 'axios'

import { socket } from '@/product/common/socket'

// import { CKEditor } from '@ckeditor/ckeditor5-react'
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic'

let serverTime = new Date()
const dateFormat = 'DD-MM-YYYY'
const dateTimeFormat = 'DD-MM-YYYY h:mm a'

if (socket) {
    socket.on('sliservertime', (data) => {
        if (moment(data.dTime).isValid()) {
            serverTime = new Date(data.dTime)
        }
    })
}

export const handleRedirectInternal = (history, path) => {
    history.push(`/${path}`)
    window.scrollTo(0, 0)
}
export const dateFormatFront = (data) => {
    return moment(data).isValid()
        ? `${moment(data).format('MMM Do')}, ${moment(data).format('h:mm a')}`
        : '-'
}
export const hoursMinutesFormateFunction = (data) => {
    if (data) {
        const hours = Math.floor(data / 60)
        const remainingMinutes = data % 60
        const dataReturn = hours > 2 ? 'hrs' : 'hour'

        return (
            <div>
                {`${hours > 0 ? `${hours} ${dataReturn}` : ''} ${
                    remainingMinutes > 0 ? `${remainingMinutes} minutes` : ''
                }  `}
            </div>
        )
    }
}
export const capitalize = (data) => {
    let dataReturn = '-'
    if (data) {
        data = data.replace(/_/g, ' ').toLowerCase()
        data.split(' ')
        if (data instanceof Array) {
            dataReturn = data
                .map((word) => {
                    return word[0].toUpperCase() + word.substring(1)
                })
                .join(' ')
        } else {
            dataReturn = data.charAt(0).toUpperCase() + data.slice(1)
        }
    }
    return dataReturn
}

export const paymentTypeRosoom = (data, t) => {
    let paymentType
    switch (data) {
        case 'CBDD':
            paymentType = t('cbd_direct_debit')
            break
        case 'CCGV':
            paymentType = t('visa_card')
            break
        case 'CCGM':
            paymentType = t('master_card')
            break
        case 'CBDC–CBD':
            paymentType = t('cbd_corporate_direct_debit')
            break
        case 'HSBC–HCBC':
            paymentType = t('hcbc_corporate_direct_debit')
            break
        case 'EBDD':
            paymentType = t('emirates_nbd_bank_direct_debit')
            break
        case 'SCBD':
            paymentType = t('standard_chartered_direct_debit')
            break
        case 'HBZD':
            paymentType = t('habib_bank_direct_debit')
            break
        case 'MBLC':
            paymentType = t('mashreq_bank_corporate_direct_debit')
            break
        case 'DIBD':
            paymentType = t('dubai_islamic_bank_direct_debit')
            break
        case 'SCBC':
            paymentType = t('standard_chartered_corporate_direct_debit')
            break
        case 'MOBE':
            paymentType = t('ministry_of_finance_industry_blue')
            break

        case 'MOGE':
            paymentType = t('ministry_of_finance_industry_gold')
            break
        case 'MORE':
            paymentType = t('ministry_of_finance_industry')
            break
        default:
            paymentType = data
    }
    return paymentType
}

export const dateFormatFrontDay = (data) => {
    return `${moment(data).format('MMM Do YYYY')}`
}

export const currencyFormat = (data) => {
    return `${parseFloat(data).toLocaleString('en-GB', {
        style: 'currency',
        currency: 'GBP',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    })}`
}

export const dateFormatFunction = (data) => {
    let dataReturn = '-'
    if (data) {
        if (moment(data).isValid()) {
            dataReturn = `${moment(data).format(dateFormat)}`
        }
    }
    return dataReturn
}

export const checkProductOpen = (date_added, user_role) => {
    let startDate = new Date(serverTime)
    let addDate = new Date(date_added)
    let milliSeconds = 0
    // if (parseInt(user_role) !== 3) {
    //   milliSeconds = 1 * 3600000;
    // } else {
    // }
    let incrementedTime = addDate.getTime() + parseInt(milliSeconds)
    let newaddDate = new Date(incrementedTime)
    if (newaddDate > startDate) {
        return false
        // let incrementedTime = addDate.getTime() + parseInt(milliSeconds);
        // let timerTime = incrementedTime - startDate.getTime();
        // if (timerTime <= 0) {
        //   return true;
        // } else {
        //   return false;
        // }
    } else {
        return true
    }
}

export const maskEmailFront = (data) => {
    data = data.toString()
    var first4 = data.substring(0, 4)
    var last5 = data.substring(data.length - 5)
    var mask = data.substring(4, data.length - 5).replace(/[^]/g, '*')
    return first4 + mask + last5
}

export const dateFormatFrontOnlyDate = (data) => {
    return `${moment(data).format(dateFormat)}`
}

export const dateTimeFormatFunction = (data) => {
    let dataReturn = '-'
    if (data) {
        if (moment(data).isValid()) {
            dataReturn = `${moment(data).format(
                global?.defaultDateTimeFormat
                    ? global.defaultDateTimeFormat
                    : dateTimeFormat
            )}`
        }
    }
    return dataReturn
}
export const timeFormatFunction = (data, customFormate = '') => {
    let dataReturn = '-'
    if (data) {
        if (moment(data).isValid()) {
            if (customFormate) {
                dataReturn = `${moment(data).format(customFormate)}`
            } else {
                dataReturn = `${moment(data).format('h a')}`
            }
        }
    }
    return dataReturn
}
export const DirectAPICAll = (method, url) => {
    return new Promise(async (resolve, reject) => {
        try {
            if (method === 'get') {
                let res = await axios.get(`${url}`)
                console.log('responsode from api', res)
                resolve(res)
            } else if (method === 'post') {
                let res = await axios.post(`${url}`)
                resolve(res)
            }
        } catch (err) {
            console.log('responsode error from api', err)
            resolve(err)
        }
    })
}

export const useCustomMediaQuery = (queryString) => {
    const [isMatch, setIsMatch] = useState(false)
    const mqChange = (mq) => {
        setIsMatch(mq.matches)
    }

    useEffect(() => {
        const mq = window.matchMedia(queryString)
        mq.addListener(mqChange)
        mqChange(mq)

        return () => {
            mq.removeListener(mqChange)
        }
    }, [queryString])

    return isMatch
}

export const LINKEDIN_REGEX =
    /^(https?:\/\/)?(www\.)?linkedin\.com\/in\/[A-Za-z0-9_-]+\/?$/i
export function normalizeLinkedInUrl(url) {
    if (!url) return url

    url = url.replace(/^linkedin:\/\/in\//, 'https://www.linkedin.com/in/')

    const redirectMatch = url.match(
        /linkedin\.com\/redir\/redirect\?url=([^&]+)/
    )
    if (redirectMatch) {
        url = decodeURIComponent(redirectMatch[1])
    }

    // Remove query params
    url = url.split('?')[0]

    // Ensure https scheme
    if (!/^https?:\/\//i.test(url)) {
        url = 'https://' + url
    }

    // ✅ Decode any encoded characters (like %C3%A1 → á)
    try {
        url = decodeURI(url)
    } catch (e) {
        // ignore if malformed
    }

    return url
}
